import { Component, Input } from '@angular/core';

@Component({
	selector: 'vb-page-header',
	styleUrls: ['./vb-ui-page-header.ng.less'],
	templateUrl: './VbPageHeader.Component.html',
})
export class VbPageHeaderComponent {
	@Input() public headerText: string;
	@Input() public themedBorder: boolean;
}
